import React from 'react';
import { ThemeLoader } from '@sightworks/theme';
import RawPlaintextBlock from '../../raw/plaintext/block';

let PlaintextBlock = (props, ref) => <RawPlaintextBlock {...props} ref={ref} />;
export default ThemeLoader(PlaintextBlock);



